import { createUserPreviewCacheRuntime, type UserPreviewCacheRuntime } from './user-preview-cache.runtime';

export { USER_PREVIEW_CACHE_TTL_MS } from './user-preview-cache.runtime';
export {
  COLLECTION_ID as USER_PREVIEW_COLLECTION_ID,
  DEBUG_NAMESPACE as USER_PREVIEW_CACHE_DEBUG_NAMESPACE,
  type UserPreviewCacheDetailLevel,
  type UserPreviewCacheEntry,
  type UserPreviewCacheLookupMetadata,
  type UserPreviewCachePatch,
  type UserPreviewCacheRecord,
  type UserPreviewCacheSnapshot,
  type UserPreviewCacheStorageRecord,
} from './user-preview-cache.types';

// Default singleton runtime, created eagerly to preserve previous behavior.
const runtime: UserPreviewCacheRuntime = await createUserPreviewCacheRuntime();

export const {
  getUserPreviewCacheEntry,
  setUserPreviewCacheEntry,
  upsertUserPreviewCacheEntry,
  invalidateUserPreviewCacheEntry,
  resetUserPreviewCacheForTests,
  primeUserPreviewCacheFromProfile,
  primeUserPreviewCacheFromPreview,
  dehydrateUserPreviewCache,
  hydrateUserPreviewCache,
  inflateUserPreviewCacheRecord,
  resolveUserPreviewCacheKeys,
  resolveUserPreviewCacheKey,
  resolveUserPreviewCacheLookup,
  hasMeaningfulPreview,
  publishDebugSnapshot,
  bootstrapStoreFromCollection,
  resolveExistingPrimaryKey,
  storage,
} = runtime;

export const userPreviewCollection = runtime.storage.collection;
